/** @jsxImportSource react */
import { Box, Tab, Tabs, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import WebFormsTab from '../../components/integrations/WebFormsTab'
import ApiKeysTab from '../../components/integrations/ApiKeysTab'
import WebhooksTab from '../../components/integrations/WebhooksTab'

const TABS = [
  { value: 'forms', label: 'Web forms', Component: WebFormsTab },
  { value: 'api', label: 'API keys', Component: ApiKeysTab },
  { value: 'webhooks', label: 'Webhooks', Component: WebhooksTab },
]

/** Admins: getting data in (web forms, API keys) and out (webhooks). */
const IntegrationsPage = () => {
  const [params, setParams] = useSearchParams()
  const tab = TABS.find((t) => t.value === params.get('tab')) || TABS[0]
  return (
    <Box sx={{ maxWidth: 960 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>Integrations</Typography>
      <Tabs value={tab.value} onChange={(_, v) => setParams({ tab: v }, { replace: true })} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
        variant="scrollable" allowScrollButtonsMobile>
        {TABS.map((t) => <Tab key={t.value} value={t.value} label={t.label} />)}
      </Tabs>
      <tab.Component />
    </Box>
  )
}

export default IntegrationsPage
